module.exports = __webpack_public_path__ + "static/img/8.e85311d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/sp/8.png
// module id = XwD7
// module chunks = 0